/*
 * Homepage contact form (sections/home-contact.liquid):
 * inquiry-type pills that reveal the message field, prefill from the team
 * configurator and the homepage pricing picker, Cmd/Ctrl+Enter submit, and a
 * searchable country picker.
 * The countries enabled in Shopify markets come from the section as JSON in
 * <script type="application/json" id="contact-country-supported">.
 */
(function () {
    // Clean up URL after successful submission (removes Shopify's query params)
    if (document.querySelector('.contact-form__success')) {
      history.replaceState(null, '', window.location.pathname + '#contact');
      // Clear any stored team config after successful submission
      localStorage.removeItem('xboat_team_config');
      return;
    }

    const form = document.getElementById('contact-form');
    if (!form) return;

    initCountryCombobox();

    const messageField = document.getElementById('message-field');
    const messageTextarea = document.getElementById('contact-message');
    const submitBtn = document.getElementById('contact-submit');
    const pillInputs = form.querySelectorAll('.contact-form__pill-input');
    const quotePill = document.getElementById('inquiry-quote');

    // Placeholder text based on inquiry type
    const placeholders = {
      'Quote': 'What are you looking for?',
      'Support': 'Describe the issue',
      'Other': 'Tell us more...'
    };

    // The message field animates open via an overflow:hidden grid trick. The country
    // dropdown is positioned absolutely and would be clipped by that, so once the
    // expand animation has finished we let the wrapper overflow visible (it never
    // collapses again once a pill is chosen).
    const messageInner = messageField ? messageField.querySelector('div') : null;
    function revealMessageField() {
      messageField.classList.add('is-visible');
      if (messageInner) {
        setTimeout(function () { messageInner.style.overflow = 'visible'; }, 350);
      }
    }


    // Once the visitor edits a prefilled message, it is theirs: don't overwrite it
    if (messageTextarea) {
      messageTextarea.addEventListener('input', function () {
        delete messageTextarea.dataset.prefilled;
      });
    }

    // Show message field and enable submit when pill is selected
    pillInputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.checked) {
          revealMessageField();
          submitBtn.disabled = false;
          messageTextarea.placeholder = placeholders[this.value] || 'Tell us more...';
        }
      });
    });

    // Team configurator handoff: assets/team-configurator.js (Pricing page) and
    // assets/home-pricing.js (homepage) store the chosen configuration under
    // this key and send the visitor to #contact; we prefill the message from
    // it. home-pricing.js is on this same page, so it also fires
    // 'xboat:team-config'. Change both sides together.
    function checkForTeamConfig() {
      try {
        const configData = localStorage.getItem('xboat_team_config');
        if (!configData) return;

        const config = JSON.parse(configData);

        // Only use config if it's less than 30 minutes old
        const thirtyMinutes = 30 * 60 * 1000;
        if (Date.now() - config.timestamp > thirtyMinutes) {
          localStorage.removeItem('xboat_team_config');
          return;
        }

        // Pre-fill the form
        prefillFromConfig(config);

        // Clear the stored config after using it
        localStorage.removeItem('xboat_team_config');
      } catch (e) {
        console.error('Error reading team config:', e);
      }
    }

    function prefillFromConfig(config) {
      // Select the "Quote" inquiry type
      if (quotePill) {
        quotePill.checked = true;
        quotePill.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Format the total price (team totals are USD amounts; see team-configurator.js)
      const formattedTotal = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(config.total);

      // Build the pre-filled message
      let message = `Hi,\n\nI'm interested in getting a quote for our team.\n\n`;
      message += `Configuration: ${config.configSummary} (${config.totalSeats} total seats)\n`;
      message += `Plan: ${config.plan}\n`;
      message += `Estimated Total: ${formattedTotal}`;
      if (config.pricingModel === 'lease') {
        message += '/year';
      }
      message += `\n\nPlease contact me to discuss further.`;

      // Set the message, unless the visitor has already written their own
      if (messageTextarea && (!messageTextarea.value.trim() || messageTextarea.dataset.prefilled)) {
        messageTextarea.value = message;
        messageTextarea.dataset.prefilled = 'true';
      }

      // Show the message field and enable submit
      if (messageField) {
        revealMessageField();
      }
      if (submitBtn) {
        submitBtn.disabled = false;
      }
    }

    // Check for team config on page load, and when the pricing picker on this
    // page hands one over
    checkForTeamConfig();
    document.addEventListener('xboat:team-config', checkForTeamConfig);

    
    // Cmd/Ctrl + Enter to submit
    form.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        if (!submitBtn.disabled) {
          form.submit();
        }
      }
    });

    // ---- Searchable country picker ----
    function initCountryCombobox() {
      const combobox = document.getElementById('contact-country-combobox');
      if (!combobox) return;
      const input = document.getElementById('contact-country-search');
      const hidden = document.getElementById('contact-country');
      const list = document.getElementById('contact-country-list');

      const currentIso = (combobox.dataset.defaultIso || '').toUpperCase();

      // Countries enabled in this store's Shopify markets, shown first as quick picks:
      // the current region pinned to the top, then the rest alphabetically.
      const supportedEl = document.getElementById('contact-country-supported');
      let supported = [];
      try {
        supported = supportedEl ? JSON.parse(supportedEl.textContent) : [];
      } catch (e) {
        supported = [];
      }
      const SUPPORTED = supported
        .filter(function (c) { return c.name && c.iso; })
        .sort(function (a, b) {
          if (a.iso.toUpperCase() === currentIso) return -1;
          if (b.iso.toUpperCase() === currentIso) return 1;
          return a.name.localeCompare(b.name);
        });

      // Full alphabetical list (ISO 3166-1 alpha-2). Flags are derived from the ISO code.
      const ALL_COUNTRIES = [
        { name: "Afghanistan", iso: "AF" }, { name: "Albania", iso: "AL" }, { name: "Algeria", iso: "DZ" },
        { name: "Andorra", iso: "AD" }, { name: "Angola", iso: "AO" }, { name: "Antigua & Barbuda", iso: "AG" },
        { name: "Argentina", iso: "AR" }, { name: "Armenia", iso: "AM" }, { name: "Australia", iso: "AU" },
        { name: "Austria", iso: "AT" }, { name: "Azerbaijan", iso: "AZ" }, { name: "Bahamas", iso: "BS" },
        { name: "Bahrain", iso: "BH" }, { name: "Bangladesh", iso: "BD" }, { name: "Barbados", iso: "BB" },
        { name: "Belarus", iso: "BY" }, { name: "Belgium", iso: "BE" }, { name: "Belize", iso: "BZ" },
        { name: "Benin", iso: "BJ" }, { name: "Bhutan", iso: "BT" }, { name: "Bolivia", iso: "BO" },
        { name: "Bosnia & Herzegovina", iso: "BA" }, { name: "Botswana", iso: "BW" }, { name: "Brazil", iso: "BR" },
        { name: "Brunei", iso: "BN" }, { name: "Bulgaria", iso: "BG" }, { name: "Burkina Faso", iso: "BF" },
        { name: "Burundi", iso: "BI" }, { name: "Cambodia", iso: "KH" }, { name: "Cameroon", iso: "CM" },
        { name: "Canada", iso: "CA" }, { name: "Cape Verde", iso: "CV" }, { name: "Central African Republic", iso: "CF" },
        { name: "Chad", iso: "TD" }, { name: "Chile", iso: "CL" }, { name: "China", iso: "CN" },
        { name: "Colombia", iso: "CO" }, { name: "Comoros", iso: "KM" }, { name: "Congo", iso: "CG" },
        { name: "Congo (DRC)", iso: "CD" }, { name: "Costa Rica", iso: "CR" }, { name: "Croatia", iso: "HR" },
        { name: "Cuba", iso: "CU" }, { name: "Cyprus", iso: "CY" }, { name: "Czechia", iso: "CZ" },
        { name: "Denmark", iso: "DK" }, { name: "Djibouti", iso: "DJ" }, { name: "Dominica", iso: "DM" },
        { name: "Dominican Republic", iso: "DO" }, { name: "Ecuador", iso: "EC" }, { name: "Egypt", iso: "EG" },
        { name: "El Salvador", iso: "SV" }, { name: "Equatorial Guinea", iso: "GQ" }, { name: "Eritrea", iso: "ER" },
        { name: "Estonia", iso: "EE" }, { name: "Eswatini", iso: "SZ" }, { name: "Ethiopia", iso: "ET" },
        { name: "Fiji", iso: "FJ" }, { name: "Finland", iso: "FI" }, { name: "France", iso: "FR" },
        { name: "Gabon", iso: "GA" }, { name: "Gambia", iso: "GM" }, { name: "Georgia", iso: "GE" },
        { name: "Germany", iso: "DE" }, { name: "Ghana", iso: "GH" }, { name: "Greece", iso: "GR" },
        { name: "Grenada", iso: "GD" }, { name: "Guatemala", iso: "GT" }, { name: "Guinea", iso: "GN" },
        { name: "Guinea-Bissau", iso: "GW" }, { name: "Guyana", iso: "GY" }, { name: "Haiti", iso: "HT" },
        { name: "Honduras", iso: "HN" }, { name: "Hong Kong", iso: "HK" }, { name: "Hungary", iso: "HU" },
        { name: "Iceland", iso: "IS" }, { name: "India", iso: "IN" }, { name: "Indonesia", iso: "ID" },
        { name: "Iran", iso: "IR" }, { name: "Iraq", iso: "IQ" }, { name: "Ireland", iso: "IE" },
        { name: "Israel", iso: "IL" }, { name: "Italy", iso: "IT" }, { name: "Ivory Coast", iso: "CI" },
        { name: "Jamaica", iso: "JM" }, { name: "Japan", iso: "JP" }, { name: "Jordan", iso: "JO" },
        { name: "Kazakhstan", iso: "KZ" }, { name: "Kenya", iso: "KE" }, { name: "Kiribati", iso: "KI" },
        { name: "Kosovo", iso: "XK" }, { name: "Kuwait", iso: "KW" }, { name: "Kyrgyzstan", iso: "KG" },
        { name: "Laos", iso: "LA" }, { name: "Latvia", iso: "LV" }, { name: "Lebanon", iso: "LB" },
        { name: "Lesotho", iso: "LS" }, { name: "Liberia", iso: "LR" }, { name: "Libya", iso: "LY" },
        { name: "Liechtenstein", iso: "LI" }, { name: "Lithuania", iso: "LT" }, { name: "Luxembourg", iso: "LU" },
        { name: "Macao", iso: "MO" }, { name: "Madagascar", iso: "MG" }, { name: "Malawi", iso: "MW" },
        { name: "Malaysia", iso: "MY" }, { name: "Maldives", iso: "MV" }, { name: "Mali", iso: "ML" },
        { name: "Malta", iso: "MT" }, { name: "Marshall Islands", iso: "MH" }, { name: "Mauritania", iso: "MR" },
        { name: "Mauritius", iso: "MU" }, { name: "Mexico", iso: "MX" }, { name: "Micronesia", iso: "FM" },
        { name: "Moldova", iso: "MD" }, { name: "Monaco", iso: "MC" }, { name: "Mongolia", iso: "MN" },
        { name: "Montenegro", iso: "ME" }, { name: "Morocco", iso: "MA" }, { name: "Mozambique", iso: "MZ" },
        { name: "Myanmar", iso: "MM" }, { name: "Namibia", iso: "NA" }, { name: "Nauru", iso: "NR" },
        { name: "Nepal", iso: "NP" }, { name: "Netherlands", iso: "NL" }, { name: "New Zealand", iso: "NZ" },
        { name: "Nicaragua", iso: "NI" }, { name: "Niger", iso: "NE" }, { name: "Nigeria", iso: "NG" },
        { name: "North Korea", iso: "KP" }, { name: "North Macedonia", iso: "MK" }, { name: "Norway", iso: "NO" },
        { name: "Oman", iso: "OM" }, { name: "Pakistan", iso: "PK" }, { name: "Palau", iso: "PW" },
        { name: "Palestine", iso: "PS" }, { name: "Panama", iso: "PA" }, { name: "Papua New Guinea", iso: "PG" },
        { name: "Paraguay", iso: "PY" }, { name: "Peru", iso: "PE" }, { name: "Philippines", iso: "PH" },
        { name: "Poland", iso: "PL" }, { name: "Portugal", iso: "PT" }, { name: "Qatar", iso: "QA" },
        { name: "Romania", iso: "RO" }, { name: "Russia", iso: "RU" }, { name: "Rwanda", iso: "RW" },
        { name: "Saint Kitts & Nevis", iso: "KN" }, { name: "Saint Lucia", iso: "LC" },
        { name: "Saint Vincent & the Grenadines", iso: "VC" }, { name: "Samoa", iso: "WS" },
        { name: "San Marino", iso: "SM" }, { name: "Sao Tome & Principe", iso: "ST" }, { name: "Saudi Arabia", iso: "SA" },
        { name: "Senegal", iso: "SN" }, { name: "Serbia", iso: "RS" }, { name: "Seychelles", iso: "SC" },
        { name: "Sierra Leone", iso: "SL" }, { name: "Singapore", iso: "SG" }, { name: "Slovakia", iso: "SK" },
        { name: "Slovenia", iso: "SI" }, { name: "Solomon Islands", iso: "SB" }, { name: "Somalia", iso: "SO" },
        { name: "South Africa", iso: "ZA" }, { name: "South Korea", iso: "KR" }, { name: "South Sudan", iso: "SS" },
        { name: "Spain", iso: "ES" }, { name: "Sri Lanka", iso: "LK" }, { name: "Sudan", iso: "SD" },
        { name: "Suriname", iso: "SR" }, { name: "Sweden", iso: "SE" }, { name: "Switzerland", iso: "CH" },
        { name: "Syria", iso: "SY" }, { name: "Taiwan", iso: "TW" }, { name: "Tajikistan", iso: "TJ" },
        { name: "Tanzania", iso: "TZ" }, { name: "Thailand", iso: "TH" }, { name: "Timor-Leste", iso: "TL" },
        { name: "Togo", iso: "TG" }, { name: "Tonga", iso: "TO" }, { name: "Trinidad & Tobago", iso: "TT" },
        { name: "Tunisia", iso: "TN" }, { name: "Turkey", iso: "TR" }, { name: "Turkmenistan", iso: "TM" },
        { name: "Tuvalu", iso: "TV" }, { name: "Uganda", iso: "UG" }, { name: "Ukraine", iso: "UA" },
        { name: "United Arab Emirates", iso: "AE" }, { name: "United Kingdom", iso: "GB" },
        { name: "United States", iso: "US" }, { name: "Uruguay", iso: "UY" }, { name: "Uzbekistan", iso: "UZ" },
        { name: "Vanuatu", iso: "VU" }, { name: "Vatican City", iso: "VA" }, { name: "Venezuela", iso: "VE" },
        { name: "Vietnam", iso: "VN" }, { name: "Yemen", iso: "YE" }, { name: "Zambia", iso: "ZM" },
        { name: "Zimbabwe", iso: "ZW" }
      ];

      // ISO alpha-2 -> regional-indicator flag emoji.
      function flag(iso) {
        if (!iso || iso.length !== 2) return '';
        const cp = iso.toUpperCase().split('').map(function (c) {
          return 0x1F1E6 + c.charCodeAt(0) - 65;
        });
        return String.fromCodePoint.apply(null, cp);
      }

      let options = [];     // currently rendered selectable <li> elements
      let activeIndex = -1;

      function makeOption(country) {
        const li = document.createElement('li');
        li.className = 'contact-form__country-option';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.id = 'country-opt-' + options.length;
        li.dataset.name = country.name;
        li.dataset.iso = country.iso;
        const flagSpan = document.createElement('span');
        flagSpan.className = 'contact-form__country-option-flag';
        flagSpan.setAttribute('aria-hidden', 'true');
        flagSpan.textContent = flag(country.iso);
        const nameSpan = document.createElement('span');
        nameSpan.textContent = country.name;
        li.appendChild(flagSpan);
        li.appendChild(nameSpan);
        // mousedown (not click) so it fires before the input's blur closes the list
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          select(country);
        });
        options.push(li);
        return li;
      }

      function makeDivider() {
        const li = document.createElement('li');
        li.className = 'contact-form__country-divider';
        li.setAttribute('role', 'presentation');
        return li;
      }

      function render(query) {
        list.innerHTML = '';
        options = [];
        const q = query.trim().toLowerCase();

        if (!q) {
          if (SUPPORTED.length) {
            SUPPORTED.forEach(function (c) { list.appendChild(makeOption(c)); });
            list.appendChild(makeDivider());
          }
          ALL_COUNTRIES.forEach(function (c) { list.appendChild(makeOption(c)); });
        } else {
          const matches = ALL_COUNTRIES
            .filter(function (c) { return c.name.toLowerCase().indexOf(q) !== -1; })
            .sort(function (a, b) {
              const aStarts = a.name.toLowerCase().indexOf(q) === 0 ? 0 : 1;
              const bStarts = b.name.toLowerCase().indexOf(q) === 0 ? 0 : 1;
              return aStarts - bStarts || a.name.localeCompare(b.name);
            });
          if (!matches.length) {
            const empty = document.createElement('li');
            empty.className = 'contact-form__country-empty';
            empty.textContent = 'No matching country';
            list.appendChild(empty);
          } else {
            matches.forEach(function (c) { list.appendChild(makeOption(c)); });
          }
        }
        activeIndex = -1;
        updateActive();
      }

      function updateActive() {
        options.forEach(function (li, i) {
          const on = i === activeIndex;
          li.classList.toggle('is-active', on);
          li.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) {
            input.setAttribute('aria-activedescendant', li.id);
            li.scrollIntoView({ block: 'nearest' });
          }
        });
        if (activeIndex < 0) input.removeAttribute('aria-activedescendant');
      }

      function open(query) {
        if (list.hidden) {
          list.hidden = false;
          combobox.classList.add('is-open');
          input.setAttribute('aria-expanded', 'true');
        }
        render(query);
      }

      function close() {
        if (list.hidden) return;
        list.hidden = true;
        combobox.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
      }

      // The confirmed country (what actually posts). Seeded from the server-side
      // default (storefront locale country) and updated only when an option is chosen.
      let committed = { name: hidden.value || '', iso: '' };
      if (committed.name) {
        const match = SUPPORTED.concat(ALL_COUNTRIES).filter(function (c) {
          return c.name === committed.name;
        })[0];
        if (match) committed.iso = match.iso;
      }

      // Display string for the settled field: flag + name, matching the dropdown rows.
      function displayValue() {
        if (!committed.name) return '';
        const f = flag(committed.iso);
        return f ? f + ' ' + committed.name : committed.name;
      }

      function select(country) {
        committed = { name: country.name, iso: country.iso || '' };
        hidden.value = country.name;
        close();
        input.value = displayValue();
        input.blur();
      }

      // Clear the box and show the full list. Used on every fresh entry so the user
      // always starts from an empty field rather than editing into the existing value.
      function openFresh() {
        input.value = '';
        open('');
      }

      // Restore the settled flag + name in the visible input (e.g. after the user
      // typed a partial query but didn't pick anything).
      function restore() {
        input.value = displayValue();
      }

      // Mirror the confirmed default into the visible input on load.
      restore();

      input.addEventListener('focus', openFresh);

      // A click on an already-focused input won't refire focus, so reopen here.
      input.addEventListener('mousedown', function () {
        if (document.activeElement === input && list.hidden) openFresh();
      });

      input.addEventListener('input', function () {
        open(input.value);
      });

      function move(delta) {
        if (list.hidden) open('');
        if (!options.length) return;
        if (activeIndex < 0) {
          activeIndex = delta > 0 ? 0 : options.length - 1;
        } else {
          activeIndex = (activeIndex + delta + options.length) % options.length;
        }
        updateActive();
      }

      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          move(1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          move(-1);
        } else if (e.key === 'Tab') {
          // Cycle the filtered options instead of leaving the field while it's open.
          if (!list.hidden && options.length) {
            e.preventDefault();
            move(e.shiftKey ? -1 : 1);
          }
        } else if (e.key === 'Enter') {
          if (!list.hidden) {
            e.preventDefault();
            if (activeIndex < 0 && options.length) activeIndex = 0;
            const li = options[activeIndex];
            if (li) select({ name: li.dataset.name, iso: li.dataset.iso });
          }
        } else if (e.key === 'Escape') {
          restore();
          close();
        }
      });

      // Leaving the field without choosing: discard the partial query, keep the
      // confirmed country. Delayed so an option's mousedown selection runs first.
      input.addEventListener('blur', function () {
        setTimeout(function () {
          if (document.activeElement === input) return;
          restore();
        }, 150);
      });

      document.addEventListener('click', function (e) {
        if (!combobox.contains(e.target)) close();
      });
    }
})();
